import { Nullable } from "@sunrise/utils";
import { AxiosInstance } from "axios";
import { atom } from "jotai";

import { PrivateApiClient } from "./private-api-client";

export const httpClientAtom = atom<{
  privateApi: Nullable<InstanceType<typeof PrivateApiClient>>;
  publicApi: Nullable<AxiosInstance>;
}>({
  privateApi: null,
  publicApi: null,
});
